import React from "react";

const DotLoaderCircle = ({ text = "", style = {} }) => {
  return !!text ? (
    <div className="d-flex justify-content-center align-items-center auth-wrapper">
      <Loader style={style} />
      <p className="m-0 p-0 ms-3">{text}</p>
    </div>
  ) : (
    <Loader />
  );
};

export default DotLoaderCircle;

const Loader = ({ style = {} }) => {
  return (
    <div
      className="dot-loader-circle d-flex align-items-center"
      style={{
        paddingLeft: "8px",
      }}
    >
      {/* <div className="col-3">
        <div className="snippet" data-title="dot-spin">
          <div className="stage">
            <div className="dot-spin"></div>
          </div>
        </div>
      </div> */}
      <span className="loader" style={style}></span>
    </div>
  );
};
